import { render } from "./EntityCard.vue?vue&type=template&id=0ada11a4"
import script from "./EntityCard.vue?vue&type=script&lang=js"
export * from "./EntityCard.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__